module.exports = __webpack_public_path__ + "img/54.1ee4ae80.jpg";